export function sidebarFilterEvents() {
	const rangeSlider = document.querySelector(".flux-range-slider");
	const sidebarForm = document.querySelector(".flux-woo-sidebar-form");
	const sidebarFilter = document.querySelector("#open-sidebar-filter");
	let modulePromise = null;
	const desktopMedia = window.matchMedia("(min-width: 1200px)");
	const loadModule = () => {
		if (!modulePromise) {
			modulePromise = import(
				"../../../../sections/woo-sidebar/orion/js/sidebar-filter.js"
			);
		}
		return modulePromise;
	};

	if ((rangeSlider || sidebarForm) && desktopMedia.matches) {
		loadModule()
			.then(({ initSidebarFilter }) => initSidebarFilter())
			.catch((err) => console.error("Failed to load module:", err));
	}

	if (!sidebarFilter) return;
	async function firstClick(e) {
		sidebarFilter.removeEventListener("click", firstClick);
		try {
			const { initSidebarFilter } = await loadModule();
			const openSidebarFilter = initSidebarFilter();
			openSidebarFilter(e);
		} catch (err) {
			console.error("Failed to load module:", err);
		}
	}
	sidebarFilter.addEventListener("click", firstClick);
}
